import { createReducer, on } from '@ngrx/store';

import * as actions from '@recent-searches/store/actions/recent-searches.actions';
import { RecentSearchModel } from '@recent-searches/entities/recent-search';

export const initialState: RecentSearchModel[] = [];

export const recentSearchesReducer = createReducer(
  initialState,
  on(actions.fetchRecentSearchesSuccessAction, (state, { response }) => response),
  on(actions.deleteRecentSearchesSuccessAction, () => initialState)
);
